import React from 'react'
import { api } from 'xadmin'
import { Select, Button } from 'antd'

const SafeSelect = (props) => {
  const [options, setOptions] = React.useState([])

  React.useEffect(() => {
    api({ name: 'core/safezone' }).fetch('', {}).then(({ json = [] }) => {
      const { ignore = [] } = props
      setOptions(
        json.filter(item => ignore.indexOf(item.id) === -1)
        .map(item => ({ value: item.id, label: item.name }))
      )
    })
  }, [])

  return <Select
    {...props}
    mode="multiple"
    allowClear
    options={options}
    filterOption={(input, option) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
    }
  />
}

const RoleSafePage = ({ item, saveItem }) => {
  const [val, setVal] = React.useState(item?.highSetting?.safe)

  const save = () => {
    saveItem({ id: item.id, highSetting: { safe: val } })
  }

  return <>
    <span style={{ fontSize: 13, marginLeft: 50 }}>安全区设置：</span>
    <SafeSelect style={{ width: '80%' }} value={val} onChange={setVal} /><br/>
    <Button style={{ margin: '10px 128px'}} type="primary" onClick={save} >保存</Button>
  </>
}

const UserSafePage = ({ item, saveItem }) => {
  const [val, setVal] = React.useState(item?.highSetting?.safe)

  const save = () => {
    saveItem({ id: item.id, highSetting: { safe: val } })
  }
  let inherit = []
  item.department?.forEach(d => {
    if (d?.highSetting?.safe?.length > 0) inherit.push(...d.highSetting.safe)
  })
  item.roles?.forEach(r => {
    if (r?.highSetting?.safe?.length > 0) inherit.push(...r.highSetting.safe)
  })
  // 个人设置中，部门和角色详情，存在 ObjList 属性中
  item.departmentObjList?.forEach(d => {
    if (d?.highSetting?.safe?.length > 0) inherit.push(...d.highSetting.safe)
  })
  item.rolesObjList?.forEach(r => {
    if (r?.highSetting?.safe?.length > 0) inherit.push(...r.highSetting.safe)
  })

  return <>
    <span style={{ fontSize: 13, marginLeft: 50 }}>继承安全区：</span>
    <SafeSelect disabled style={{ width: '80%', marginBottom: 10 }} value={_.uniq(inherit)} /><br/>
    <span style={{ fontSize: 13, marginLeft: 37 }}>自定义安全区：</span>
    <SafeSelect style={{ width: '80%' }} value={val} onChange={setVal} ignore={_.uniq(inherit)} /><br/>
    <Button style={{ margin: '10px 128px'}} type="primary" onClick={save} >保存</Button>
  </>
}

export { RoleSafePage, UserSafePage, SafeSelect }
